<template>
  <div>
    <LeftListMember :pos="3"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li">
            <router-link to="/center-equity" class="txt">会员权益</router-link>
          </li>
          <li class="li on">
            <router-link to="/center-recharge" class="txt">在线充值</router-link>
          </li>
          <li class="li">
            <router-link to="/center-record" class="txt">充值记录</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="m-infobox6">
            <form onsubmit="return false;">
              <div class="form">
                <div class="group group1">
                  <div class="txt">套餐类型：</div>
                  <div class="infobox selbox">
                    <el-radio-group v-model="vipType" fill="#333">
                      <el-radio label="vip">会员开通/续费 </el-radio>
                      <el-radio label="download">数据下载套餐</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="group group1">
                  <div class="txt">套餐：</div>
                  <div class="infobox selbox">
                    <el-select v-model="form.vipId" placeholder="请选择">
                      <el-option v-for="vip in vipList" :key="vip.id"
                                 :label="`${vip.price}元/会员VIP/${vip.daysText}`"
                                 :value="vip.id"
                      ></el-option>
                    </el-select>
                    <!-- <img src="@/assets/images/arr1.png" class="icon" alt="" /> -->
                  </div>
                </div>
                <div class="group group2">
                  <div class="txt">支付方式：</div>
                  <div class="paybox">
                    <el-radio-group v-model="payType">
                      <el-radio-button label="wechat" class="pic on"
                        ><img src="@/assets/images/pay1.png" class="img" alt=""
                      /></el-radio-button>
                      <el-radio-button label="alipay" class="pic"
                        ><img src="@/assets/images/pay2.png" class="img" alt=""
                      /></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="group">
                  <div class="txt">发票：</div>
                  <div class="infobox selbox">
                    <el-select v-model="form.isInvoice" placeholder="请选择">
                      <el-option label="不开发票" value="0"></el-option>
                      <el-option label="开发票" value="1"></el-option>
                    </el-select>
                    <!-- <img src="@/assets/images/arr1.png" class="icon" alt="" /> -->
                  </div>
                </div>
                <div class="group">
                  <div class="txt"><span>*</span>公司名称：</div>
                  <div class="infobox inpbox">
                    <el-input
                      v-model="form.title"
                      placeholder="请输入公司名称 "
                      class="inpt"
                    ></el-input>
                  </div>
                </div>
                <div class="group">
                  <div class="txt"><span>*</span>纳税人识别号：</div>
                  <div class="infobox inpbox">
                    <el-input
                      v-model="form.registerNo"
                      placeholder="请输入税号"
                      class="inpt"
                    ></el-input>
                  </div>
                </div>
                <div class="group">
                  <div class="txt"><span>*</span>接收邮箱：</div>
                  <div class="infobox inpbox">
                    <el-input
                      v-model="form.email"
                      placeholder="请输入接收邮箱"
                      class="inpt"
                    ></el-input>
                  </div>
                </div>
                <div class="group">
                  <div class="txt"><span>*</span>联系人：</div>
                  <div class="infobox inpbox">
                    <el-input
                      v-model="form.contact"
                      placeholder="请输入联系人"
                      class="inpt"
                    ></el-input>
                  </div>
                </div>
                <div class="group group-btn">
                  <div class="infobox btnbox">
                    <!-- <button class="g-btns1"  @click="showModal">确认付款</button> -->
                    <div class="g-btns1"  @click="showModal">确认付款</div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <a-modal
      :visible="visible"
      @cancel="handleCancel"
      :footer="null"
      :centered="true"
      :closable="false"
      :width="1100"
      wrapClassName="popbox"
      :maskStyle="{backgroundColor: 'rgba(0, 0, 0, 0.75)'}"
    >
      <div class="m-popin2">
        <div class="tit">套餐 <span class="span">{{ `${buyVip.price}元/会员VIP/${buyVip.daysText}` }}</span></div>
        <div class="info">
          <img v-if="payType==='wechat'" src="@/assets/images/pay6.png" class="icon" alt="" /> <span v-if="payType==='wechat'">微信支付</span>
          <img v-if="payType==='alipay'" src="@/assets/images/pay7.png" class="icon" alt="" /> <span v-if="payType==='alipay'">支付宝支付</span>
        </div>
        <!-- <div class="info"><img src="@/assets/images/pay7.png" class="icon" alt="" />支付宝支付</div> -->
        <div v-if="payType==='wechat'" class="pic">
          <img :src="buyQrCode" class="img" alt="" />
        </div>
        <iframe v-if="payType==='alipay'" :srcdoc="buyIframeBody" frameborder="0" border="0" marginheight="0" marginwidth="0" width="220" height="220" style="overflow: hidden;"></iframe>
        <div class="ort" :style="{backgroundColor: payType==='wechat' ? 'rgb(255, 118, 116)' : 'rgb(27,171,236)'}">
          <img src="@/assets/images/pay5.png" class="icon2" alt="" />
          <div class="right">
            <div class="p">请使用{{ payType==='wechat' ? '微信' : '支付宝' }}扫一扫</div>
            <div class="p">扫描二维码</div>
          </div>
        </div>
        <!-- <div class="ort">
          <img src="@/assets/images/pay5.png" class="icon2" alt="" />
          <div class="right">
            <div class="p">请使用支付宝扫一扫</div>
            <div class="p">扫描二维码</div>
          </div>
        </div> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import LeftListMember from "@/components/LeftListMember";
import getApiData, {getApiRes, sleep} from "@/api/apiUtil";
import apiYrVipPackage from "@/api/yrVipPackage";
import QRCode from "qrcode";
import apiYrOrder from "@/api/yrOrder";
import apiUserInfo from "@/api/userInfo";
export default {
  components: {
    LeftListMember,
  },
  data() {
    return {
      vipType: 'vip',
      vipList: [],
      payType: "wechat",
      form: {
        vipId: "",
        isInvoice: "",
        title: '',
        registerNo: '',
        email: '',
        contact: '',
      },
      visible: false,
      buyVip: {},
      buyQrCode: "",
      buyIframeBody: '',
      buyOrderId: 0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo || {}
    },
  },
  watch:{
    visible(v){
      if(v){
        this.interval = setInterval(()=>{
          this.queryStatus()
        }, 3000)
      }else{
        if(this.interval) {
          clearInterval(this.interval)
          this.interval = 0
        }
        this.buyOrderId = 0
        this.buyQrCode = undefined
      }
    },
    vipType(v){
      this.loadVipList()
      this.form.vipId = ''
    }
  },
  mounted() {
    this.loadVipList()
  },
  methods: {
    async loadVipList(){
      this.vipList = await getApiData(apiYrVipPackage.getList(1,100, [['type','=',this.vipType],['userType','=',this.userInfo.type]]),0,1)
    },
    async showModal() {
      if(!this.form.vipId) return this.$message.error('请选择套餐')
      this.buyVip = this.vipList.find(x=>x.id==this.form.vipId)
      if(!this.buyVip) return this.$message.error('请选择套餐')

      if(this.form.isInvoice==1){
        if(!this.form.title) return this.$message.error('请输入发票抬头')
        if(!this.form.registerNo) return this.$message.error('请输入纳税人识别号')
        if(!this.form.email) return this.$message.error('请输入邮箱')
        if(!this.form.contact) return this.$message.error('请输入联系人')
      }

      await this.submitVip()
    },
    handleCancel(e) {
      this.visible = false;
    },
    async queryStatus(){
      if(!this.buyOrderId) return
      let re = await getApiRes(apiYrOrder.info(this.buyOrderId),0,0,0)
      if(re.code==0 && re.data){
        if(re.data.status==1){
          // 支付成功
          this.visible = false
          this.$message.success('支付成功')
          this.$store.dispatch('user/getInfo')
          await sleep(1500)
          this.$router.push('/center-record') // 跳转充值记录
        }
      }
    },
    async submitVip(){
      let re = await getApiRes(apiYrOrder.buyAndPay(this.form.vipId, this.payType, this.form), 0, 1,1)
      if(re.code==0 && re.data.code_url){
         const opts = {
           errorCorrectionLevel: 'H',
           type: 'image/png',
           quality: 0.9,
           margin: 1,
           color: {
             dark: '#000000',
             light: '#ffffff',
           },
         }
         const png = await QRCode.toDataURL(re.data.code_url, opts)
         console.log(png)
        this.buyQrCode = png
      }
      if(re.code==0 && re.data.body){
        this.buyIframeBody = re.data.body
      }
      if(re.code==0 && re.data.orderId){
        this.buyOrderId = re.data.orderId
      }
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
